import { useMemo } from "react";
import { useSondertagContext } from "../context/sondertagContext";

function normalizeAbbr(abbr) {
  return abbr?.trim().toLowerCase();
}

export default function useSondertagStats(angebote, currentUser) {
  const { teacherStats } = useSondertagContext();
  const stats = useMemo(() => {
    if (!Array.isArray(angebote)) return {};

    const sondertagStats = {};
    const jahrgangStats = {};

    let totalSlots = 0;
    let filledSlots = 0;

    const myAngebote = [];
    angebote.forEach((a) => {
      totalSlots++;

      const isFilled =
        a.owners?.some(
          (owner) => owner.abbreviation?.toLowerCase() !== "leer",
        ) ?? false;
      if (isFilled) filledSlots++;

      // ✅ track my slots
      if (currentUser && a.owners?.some((o) => o.id === currentUser.id)) {
        myAngebote.push(a);
      }

      // =================================================
      // ✅ SONDERtAG LEVEL
      // =================================================
      if (!sondertagStats[a.sondertagId]) {
        sondertagStats[a.sondertagId] = {
          sondertagId: a.sondertagId,
          label: a.sondertagLabel,

          total: 0,
          filled: 0,
          free: 0,
        };
      }

      sondertagStats[a.sondertagId].total++;

      if (isFilled) {
        sondertagStats[a.sondertagId].filled++;
      }

      // =================================================
      // ✅ JAHRGANG LEVEL (per sondertag!)
      // =================================================
      const jKey = `${a.sondertagId}-${a.jahrgangId}`;

      if (!jahrgangStats[jKey]) {
        jahrgangStats[jKey] = {
          sondertagId: a.sondertagId,
          jahrgangId: a.jahrgangId,
          jahrgangTitle: a.jahrgangTitle,

          total: 0,
          filled: 0,
          free: 0,
        };
      }

      jahrgangStats[jKey].total++;

      if (isFilled) {
        jahrgangStats[jKey].filled++;
      }
    });

    // ✅ finalize free counts
    Object.values(sondertagStats).forEach((s) => {
      s.free = s.total - s.filled;
    });

    Object.values(jahrgangStats).forEach((j) => {
      j.free = j.total - j.filled;
    });

    const myAbbr = normalizeAbbr(currentUser?.abbreviation);

    if (myAbbr && teacherStats.length > 0 && !teacherStats[myAbbr]) {
      console.warn("No stats found for user:", currentUser?.abbreviation);
    }

    const myStats = myAbbr ? teacherStats[myAbbr] : null;

    const myTargetSlots = myStats?.target ?? 0;

    return {
      // ✅ global
      totalSlots,
      filledSlots,
      freeSlots: totalSlots - filledSlots,

      // ✅ grouped
      sondertagStats: Object.values(sondertagStats),
      jahrgangStats: Object.values(jahrgangStats),

      // ✅ user
      myAngebote,
      mySlotsCount: myAngebote.length,

      // ✅ global
      myTargetSlots,
    };
  }, [angebote, currentUser, teacherStats]);

  return stats;
}
